import { render, staticRenderFns } from "./HelpNeopag.vue?vue&type=template&id=17038d32&"
import script from "./HelpNeopag.vue?vue&type=script&lang=js&"
export * from "./HelpNeopag.vue?vue&type=script&lang=js&"
import style0 from "./HelpNeopag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports